// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2GE4p","title":"ClientCherryInfo_title__2ZiK6","itemText":"ClientCherryInfo_itemText__6yKIb"};